// Max artwork thumbnails rendered inline in a grid cell before the rest collapse
// into a "+N" overflow chip. Kept low to bound how many full-resolution source
// images are downloaded-and-resized per row on image-heavy pages (AAD-2642):
// every inline thumbnail pulls its full-res source to resize client-side, so the
// cap directly caps transient memory per visible row.
export const INLINE_THUMBNAIL_LIMIT = 4;
